exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input {\n  background-image: url('/assets/icon-search.png');\n  background-repeat: no-repeat;\n  background-position: 97% 50%;\n  padding:4px;\n  width:15em;\n  border: thin solid silver;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-input/filter-input.component.css
// module id = 388
// module chunks = 0